import React, { useState } from "react";
import { MAX_DISTANCE_OPTIONS } from "../../utils/constants";
import AutocompleteAddress from "../AddressSearch/AutocompleteAddress";
import Select from "react-select";

export default function LocationSearchComponent({
  item,
  onDataChange,
  index,
  dKey,
}) {
 
  const [location, setLocation] = useState(item[dKey] || {
    type: "Point",
    coordinates: [],
    bounding: [],
    distance: "any",
    address: "",
  });

  
  return (
    <div style={{ display: "flex", gap: "9px" }} className="group-filter-location-align">
      <AutocompleteAddress
      inherit
        address={location.address}
        diffrentiateSearch
        handleSelectBounding={(address, boundingBox, coordinates) => {
          setLocation({
            type: "Point",
            coordinates,
            bounding: boundingBox,
            address: address,
          });
          const val = {
            ...location,
            type: "Point",
            coordinates,
            bounding: boundingBox,
            address: address,
          };

          onDataChange(index, val, dKey);
        }}
      />
      {location && location.coordinates && location.coordinates.length === 2 ? (
        <Select
          name="filter-select"
          placeholder={"Select distance within"}
          value={location.distance || "any"}
          onChange={(value) => {
            setLocation({
              ...location,
              distance: value.value,
            });
            onDataChange(index,{
              ...location,
              distance: value.value,
            },dKey);
          }}
          options={MAX_DISTANCE_OPTIONS}
        />
      ) : (
        ""
      )}
    </div>
  );
}
